export interface IntegrationConnectionStatusConnected {
    type: 'VALID';
}

export function createIntegrationConnectionStatusConnected(): IntegrationConnectionStatusConnected {
    return {
        type: 'VALID',
    };
}
